import { forwardRef } from "react";
import { motion } from "motion/react";
import className from "classnames/bind";

import styles from "./MaterialLoader.module.scss";
const cx = className.bind(styles);

type MaterialLoaderProps = {
  className?: string;
};

const MaterialLoader = forwardRef<HTMLDivElement, MaterialLoaderProps>(({ className }, ref) => {
  return (
    <div className={cx("material-loader", className)} ref={ref}>
      <svg
        className={cx("material-loader__spinner")}
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className={cx("material-loader__spinner__circle")}
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
          cx="33"
          cy="33"
          r="30"
        ></circle>
      </svg>
    </div>
  );
});

export default motion.create(MaterialLoader);
